export const normalizeTime = (t) => {
  return new String(t).slice(0, 19); // trunk milliseconds
};

export const formatDate = (timestamp) => {
  try {
    const date = new Date(timestamp);
    return date.toLocaleString('de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).replace(',', '');
  } catch (e) {
    return timestamp; // fallback
  }
};
